import { Stack } from "@mui/material"
import { GenericTextField } from "../generic/GenericTextField"

export const BasicEmailForm = ({ formik, initialDirection = 'row' }) => {
  return (
    <Stack direction={{ xs: 'column', sm: initialDirection }} gap={2}>
      <GenericTextField
        value={formik.values?.name}
        onChange={(event) => formik.setFieldValue('name', event.target.value)}
        label={'Name'}
        placeholder={'Jane Doe'}
        error={Boolean(formik.errors?.name)}
        helperText={formik.errors?.name}
      />
      <GenericTextField
        value={formik.values?.email}
        onChange={(event) => formik.setFieldValue('email', event.target.value)}
        label={'Email'}
        placeholder={'janedoe@email.com'}
        error={Boolean(formik.errors?.email)}
        helperText={formik.errors?.email}
      />
    </Stack>
  )
}